(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["whatsapp-float"] && !Shopify.designMode) return;
  try {
    (function() {
    var widget = document.querySelector('[data-wa-float]');
    if (!widget) return;

    var bubble = widget.querySelector('[data-wa-bubble]');
    var closeBtn = widget.querySelector('[data-wa-bubble-close]');
    var waButton = widget.querySelector('[data-wa-button]');
    var delay = parseInt(widget.getAttribute('data-bubble-delay'), 10) * 1000;
    var dismissed = sessionStorage.getItem('wa-bubble-dismissed');

    if (!dismissed && bubble) {
      setTimeout(function() {
        bubble.setAttribute('aria-hidden', 'false');
      }, delay);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        bubble.setAttribute('aria-hidden', 'true');
        sessionStorage.setItem('wa-bubble-dismissed', '1');
      });
    }

    if (waButton) {
      waButton.addEventListener('click', function() {
        bubble.setAttribute('aria-hidden', 'true');
        sessionStorage.setItem('wa-bubble-dismissed', '1');
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
